import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check--circle",
  "use": "icon-check--circle-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-check--circle\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm1 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10ZM9.416 14.111l5.958-6.324a.953.953 0 0 0 .014-1.273.807.807 0 0 0-1.195 0l-5.361 5.688-2.389-2.546a.807.807 0 0 0-1.194 0 .938.938 0 0 0 0 1.273l2.973 3.182a.807.807 0 0 0 1.194 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol